import { createUseStyles } from 'react-jss';

import { scrollbar } from '@picsart/design-system/foundation/styleHelpers';

const useAppStyles = createUseStyles<string, any>(
  {
    '@global': {
      ':root': {
        '--backgrounds-tint-4': 'var(--backgrounds-tint-3)',
        '--backgrounds-tint-5': 'var(--backgrounds-tint-3)',
        '--backgrounds-tint-6': 'var(--backgrounds-tint-3)',
      },
      html: {
        '&.desktop:not(.embed)': {
          ...scrollbar(),
          minWidth: 1024,
        },
        '&.embed-full': {
          width: '100%',
          height: '100%',
          '& > $body': {
            width: '100%',
            height: '100%',
          },
          '& #__next': {
            width: '100%',
            height: '100%',
          },
        },
        '&.mobile': {},
      },
      body: {
        '&.no-scroll': {
          height: '100vh',
          overflow: 'hidden',
        },
      },
      '#__next': {
        containIntrinsicSize: '100vh',
      },
      '.next-image-temp': {
        position: 'absolute',
        display: 'block',
        width: 0,
        height: 0,
        padding: 0,
        inset: 0,
        minWidth: '100%',
        maxWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
      },
      '::selection': {
        color: 'var(--negative-text-default)',
        backgroundColor: 'var(--primary-base-default)',
      },
    },
  },
  {
    name: 'app',
  },
);

export default useAppStyles;
